import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import './Header.scss';
import { DarkModeSwitch } from 'react-toggle-dark-mode';

const Header = ({ isDarkMode, setDarkMode }) => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleDarkMode = () => {
    setDarkMode(!isDarkMode);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header data-theme={isDarkMode ? 'dark' : 'light'} className={scrolled ? 'header-scrolled' : ''}>
      <div className="header-inner">
        <div>
          <Link to="/">
            <h1 className="headerName">
              <span className="firstName">Vedant</span>
              <span className="lastName">Supnekar</span>
            </h1>
          </Link>
        </div>
        <div className='navbarsetting'>
          <nav id="myTopnav">
            <ul className="nav__links">
              <li className={isActive('/work') ? 'nav-active' : ''}>
                <Link to="/work">Work</Link>
              </li>
              <li className={isActive('/education') ? 'nav-active' : ''}>
                <Link to="/education">Education</Link>
              </li>
              <li id="project-click" className={isActive('/projects') ? 'nav-active' : ''}>
                <Link to="/projects">Projects</Link>
              </li>
              <li className="dark-mode-toggle">
                <DarkModeSwitch
                  checked={isDarkMode}
                  onChange={toggleDarkMode}
                  size={24}
                />
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
